import { Reveal, SectionLabel } from "./Reveal";
import { Icon } from "@/lib/icons";

export default function Faculty({ site, faculty }) {
  const s = site?.facultySection || {};
  return (
    <section id="faculty" className="py-24 lg:py-32 bg-[var(--c-bg-alt)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <SectionLabel>{s.label}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{s.title}</h2>
          <p className="font-body text-[var(--c-muted)] mt-5 text-base sm:text-lg">{s.subtitle}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-14">
          {(faculty || []).map((f, i) => (
            <Reveal key={f.id || i} delay={(i % 3) * 0.1}>
              <div data-testid={`faculty-card-${i}`} className="group text-center">
                <div className="relative mx-auto w-full max-w-[280px] aspect-[4/5] rounded-3xl overflow-hidden border border-[var(--c-border)] shadow-lg">
                  <img src={f.photo} alt={f.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 duration-700 ease-out" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--c-primary)]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-5">
                    <p className="font-body text-sm text-white/90 leading-relaxed">{f.bio}</p>
                  </div>
                </div>
                <h3 className="font-heading text-xl font-semibold text-[var(--c-primary)] mt-5">{f.name}</h3>
                <div className="font-body text-sm text-[var(--c-secondary)] mt-1">{f.role}</div>
                {(f.socials || []).length > 0 && (
                  <div className="flex items-center justify-center gap-3 mt-3">
                    {f.socials.map((so, k) => (
                      <a key={k} href={so.href || "#"} className="text-[var(--c-muted)] hover:text-[var(--c-secondary)]">
                        <Icon name={so.icon} className="h-4 w-4" />
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
